import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AdsExpensesModule } from '../../ads-expenses.module';
import { BaseAdsExpensesComponent } from '../../abstract-components/base-ads-expenses.component';
import { PageEvent } from '@angular/material/paginator';
import { filter, tap } from 'rxjs';
import { EventService } from '~app/app/~shared/services/event.service';
import { ResourceFacade } from '~app/app/~store/facades/resource.facade';
import { GlobalEvent } from '~core/models/shared.models';

@Component({
  selector: 'ads-expenses-list-page',
  standalone: true,
  imports: [AdsExpensesModule],
  templateUrl: './ads-expenses-list-page.component.html',
  styleUrl: './ads-expenses-list-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdsExpensesListPageComponent extends BaseAdsExpensesComponent {
  private _resourceFacade = inject(ResourceFacade);
  private _eventService = inject(EventService);

  resources$ = this._resourceFacade.resources$;
  isLoading$ = this._resourceFacade.isLoading$;
  currentError$ = this._resourceFacade.currentError$;
  paginationData$ = this._resourceFacade.paginationData$;

  onGlobalRefresh$ = this._eventService.events$.pipe(
    filter((ev: GlobalEvent) => ev.type === 'REFRESH_DATA'),
    tap(() => this.refreshData())
  );

  refreshData(): void {
    this._resourceFacade.getData({ refresh: true });
  }

  handlePageEvent(e: PageEvent): void {
    this._resourceFacade.setPagination({
      ...(e.pageSize && { itemPerPage: e.pageSize }),
      page: e.pageIndex + 1 || 1
    });
  }
}
